import {
  NOVIDADES_COUNT,
  NOVIDADES_LIST,
  NOVIDADES_LOAD
} from "../actions/novidades";
import { ERRORS_SHOW } from "../actions/errors";
import Api from "../../service/api-web";
import * as _ from "lodash";
const state = { contador: 0 };
const getters = {
  getNovidadesContador: state => state.contador
};

const actions = {
  [NOVIDADES_COUNT]: ({ commit }) => {
    Api.v4.novidades
      .getNew()
      .then(resp => {
        commit(NOVIDADES_COUNT, _.get(resp, "data.total", 0));
      })
      .catch(() => {
        // console.log('Falha ao buscar contador de novidades', err)
      });
  },
  [NOVIDADES_LIST]: ({ dispatch }, payload = {}) => {
    const limit = payload.limit != null ? payload.limit : 20;
    const offset = payload.offset != null ? payload.offset : 0;
    return new Promise((resolve, reject) => {
      Api.v4.novidades
        .list(limit, offset)
        .then(resp => {
          const body = resp.data;
          if (body && Array.isArray(body.data)) {
            resolve({ data: body.data, meta: body.meta || null });
          } else if (Array.isArray(body)) {
            resolve({ data: body, meta: null });
          } else {
            resolve({ data: [], meta: null });
          }
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [NOVIDADES_LOAD]: ({ dispatch }, idnovidade) => {
    return new Promise((resolve, reject) => {
      Api.v4.novidades
        .obter(idnovidade)
        .then(resp => resolve(resp.data))
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  }
};
const mutations = {
  [NOVIDADES_COUNT]: (state, payload) => {
    state.contador = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
